var _metadata, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGarage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("sfw", null, /*#__PURE__*/React.createElement("slices", null), /*#__PURE__*/React.createElement("sliceSourceBounds", {
    height: 16384,
    width: 16389,
    x: -8165,
    y: -8160,
    bottomLeftOrigin: "true"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M58.474,25.12l-26-14c-0.296-0.159-0.652-0.159-0.948,0l-26,14c-0.486,0.262-0.668,0.868-0.406,1.354    s0.868,0.669,1.354,0.406L9,25.521V52c0,0.553,0.448,1,1,1h44c0.553,0,1-0.447,1-1V25.52l2.526,1.36    c0.15,0.082,0.312,0.12,0.473,0.12c0.356,0,0.701-0.19,0.882-0.526C59.143,25.988,58.96,25.381,58.474,25.12z M17,41h30v4H17V41z     M47,39H17v-4h30V39z M17,51v-4h30v4H17z M53,51h-4V34c0-0.553-0.447-1-1-1H16c-0.552,0-1,0.447-1,1v17h-4V24.443l21-11.308    l21,11.308V51z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,21c-0.552,0-1,0.448-1,1v4c0,0.552,0.448,1,1,1h12c0.553,0,1-0.448,1-1v-4c0-0.552-0.447-1-1-1H26z M27,23h4v2h-4V23z     M37,25h-4v-2h4V25z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarage);
export default __webpack_public_path__ + "static/media/garage.07d3944b90afd5c2b0c7ecb056571a99.svg";
export { ForwardRef as ReactComponent };